import React from 'react'
import "./imageslide.css"

function ImageSlider({activeIndex,imageSlider}) {
  return (
    <div>
        {imageSlider.map((slide, index) => (
          <div className='header--slides'  key={index} style={{"backgroundColor": slide.color}}>
            <div className={index === activeIndex ? "slides active" :" inactive"} >
                <img className='slide-image' src = {slide.urls} alt="" />
                {/* <span className='slide-title'>{slide.title}</span> */}
            </div>
          </div>
        ))}
    </div>
    
  )
}

export default ImageSlider
